export function marketsAlertsTransform(data, params) {
    return {
        status: data.status,
        data: alertFormat(data, params)
    };
}
export function marketsAlertConfigTransform(data) {
    return {
        status: data.status,
        data: configFormat(data.data)
    };
}

function alertFormat(data, params) {
    data = data.data;
    if (!data) {
        return null;
    }
    const ret = {
        total: data.total,
        start: params.start,
        list: []
    };
    if (data.list && data.list.length > 0) {
        ret.list = data.list.map(alert => {
            return getAlertJSON(alert);
        });
    }
    return ret;
}

function getAlertJSON(alert) {
    if (alert.autoReset === 'Enabled') {
        alert.autoReset = true;
    } else if (alert.autoReset === 'Disabled') {
        alert.autoReset = false;
    }
    return {
        rtTicker: alert.ticker,
        autoReset: alert.autoReset,
        uniqueAlertID: alert.uniqueAlertID,
        alertID: alert.alertID,
        targetValue: alert.targetValue,
        change: alert.change,
        triggeredValue: alert.triggeredValue,
        readStatus: alert.readStatus,
        triggeredTime: alert.triggeredTime,
        localTriggeredTime: alert.localTriggeredTime,
        localTimeZone: alert.localTimeZone,
        createTime: alert.createTime
    };
}

function configFormat(config) {
    let lang;
    if (config.lang === '0') {
        lang = 'en';
    } else if (config.lang === '1') {
        lang = 'fr';
    } else {
        lang = config.lang;
    }
    if (config.profile && typeof config.profile === 'string') {
        config.profile = JSON.parse(config.profile);
    }
    return {
        email: config.alertEmail,
        language: lang,
        sendStatus: config.sendStatus,
        profile: config.profile
    };
}
